import React, { useEffect, useState } from "react";
import InvestmentSnapshot from "../../../../Components/ClientDashboard/DetailsEquity/InvestmentSnapshot";
import NetEquityPortfolio from "../../../../Components/ClientDashboard/DetailsEquity/NetEquityPortfolio";
import TradingTransaction from "../../../../Components/ClientDashboard/DetailsEquity/TradingTransaction";
import RiskProfile from "../../../../Components/ClientDashboard/DetailsEquity/RiskProfile";
import Holdings from "../../../../Components/ClientDashboard/DetailsEquity/Holdings";
import EquityPortfolioAnalysis from "../../../../Components/ClientDashboard/DetailsEquity/EquityPortfolioAnalysis";
import MarginDetails from "../../../../Components/ClientDashboard/DetailsEquity/MarginDetails";
import Analytics from "../../../../Components/ClientDashboard/DetailsEquity/Analytics";
import PayinPayout from "../../../../Components/ClientDashboard/DetailsEquity/PayinPayout/PayinPayout";
import DividendInfo from "../../../../Components/ClientDashboard/DetailsEquity/DividendInfo";
import PortfolioOverviewGainers from "../../../../Components/ClientDashboard/DetailsEquity/PortfolioOverviewGainers";
import PortfolioOverviewLooser from "../../../../Components/ClientDashboard/DetailsEquity/PortfolioOverviewLooser";
import PortfolioGrowth from "../../../../Components/ClientDashboard/DetailsEquity/PortfolioGrowth";
import PlatformWiseInfo from "../../../../Components/ClientDashboard/DetailsEquity/PlatformWiseInfo";
import IpoInfo from "../../../../Components/ClientDashboard/DetailsEquity/IpoInfo";
import {
  DASHBOARD_CLIENT_DETAIL_EQUITY,
  DASHBOARD_CLIENT_OVERVIEW,
} from "../../../../Configuration/API_URL";
import TradingTransactionNew from "../../../../Components/ClientDashboard/DetailsEquity/TradingTransactionNew";
import ClientOverview from "../../../../Components/ClientDashboard/Overview/ClientOverview";
import IncPortfolioNew from "../../../../Components/ClientDashboard/Overview/IncPortfolioNew";
import ClientSummary from "../../../../Components/ClientDashboard/DetailsEquity/ClientSummary";
import SummaryClientDetail from "../../../../Components/ClientDashboard/DetailsEquity/SummaryClientDetail";
import AnalyticsNewWrapper from "../../../../Components/ClientDashboard/DetailsEquity/AnalyticsNewWrapper";
import BrokerageTable from "../../../../Components/ClientDashboard/DetailsEquity/BrokerageTable";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../../../CommonMethhods/CommonMethods";
import HoldingNetPositionTab from "../../../../Components/ClientDashboard/DetailsEquity/HoldingNetPositionTab/HoldingNetPositionTab";
import axiosInstance from "../../../../CommonMethhods/axiosInstance";

function DetailsEquity(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const cosmosRid = localStorage.getItem("cosmosRid");
  const [investEquity, setInvestEquity] = useState();
  const [risk, setRisk] = useState();
  const [netPortfolio, setNetPortfolio] = useState();
  const [netEquityLoader, setNetEquityLoader] = useState(true);
  const [portAnalysis, setPortAnalysis] = useState();
  const [smallLoader, setSmallLoader] = useState(false);

  const getPortAnalysisDetails = async (clientCode) => {
    setSmallLoader(true);
    let payloadValue = { clientCode: clientCode };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getAnalysis = await axiosInstance.post(
        DASHBOARD_CLIENT_OVERVIEW.PortfolioAnalysis_URL,
        `"${encPayload}"`,
      );
      const response = ApiResDecrypt(getAnalysis?.data);
      const res = response.data;
      setPortAnalysis(res);
      setSmallLoader(false);
    } catch (error) {
      console.log(error);
      setSmallLoader(false);
      setSmallLoader(false);
    }
  };

  const getInvestEquityDetails = async (clientCode) => {
    let payloadValue = {};
    let encPayload = AESEncryption(payloadValue);
    try {
      const getEquity = await axiosInstance.post(
        DASHBOARD_CLIENT_DETAIL_EQUITY.InvestmentSnapshot_URL + clientCode,
        `"${encPayload}"`,
      );
      const response2 = ApiResDecrypt(getEquity?.data);
      const res1 = response2.data;
      setInvestEquity(res1);
      setRisk(res1.riskProfile);
      setNetPortfolio(res1.portfolio);
      setNetEquityLoader(false);
    } catch (error) {
      console.log(error);
      setNetEquityLoader(false);
    }
  };
  useEffect(() => {
    let clientCode = "";
    if (localStorage.getItem("clientCode")) {
      clientCode = localStorage.getItem("clientCode");
      getInvestEquityDetails(clientCode);
      getPortAnalysisDetails(clientCode);
    }
  }, []);

  console.log(cosmosRid, "cosmosRid");

  return (
    <>
      <InvestmentSnapshot
        investmentSnapshot={
          investEquity === undefined || null ? "-" : investEquity
        }
        loader={smallLoader}
      />

      <SummaryClientDetail />
      <BrokerageTable />

      {/* <!-- portfolio and risk profile --> */}
      <div className="row bottom-25">
        {/* <!-- risk profile --> */}
        {/* <RiskProfile
          riskProfileData={risk === undefined || null ? "-" : risk}
        /> */}

        <ClientSummary />

        <NetEquityPortfolio
          netEquityPortfolio={
            netPortfolio === undefined || null ? "-" : netPortfolio
          }
          netEquityLoader={netEquityLoader}
        />
      </div>

      {/* <!-- equity tab elements ends --> */}
      {/* <!-- trading transactions --> */}
      {/* <TradingTransaction /> */}
      <TradingTransactionNew />
      {/* <Holdings /> */}
      {(cosmosRid === "10" || cosmosRid === "11" || cosmosRid === "12") &&
        <HoldingNetPositionTab/>
      }

      {/* <!-- equity slider --> */}
      <div className="row bottom-25">
        <EquityPortfolioAnalysis />
        <MarginDetails />
      </div>

      {/* <!-- analytics section --> */}
      {/* <Analytics /> */}
      <AnalyticsNewWrapper />

      {/* <!-- payin and pyout details and portfolio growth section --> */}
      <div className="row bottom-25">
        <PayinPayout />
        {/* <IncPortfolioNew /> */}
        {/* <PortfolioGrowth /> */}
      </div>
      {/* <!-- platform Dividend Ipo --> */}
      <div className="row bottom-25">
        <PlatformWiseInfo />

        <DividendInfo />
        <IpoInfo />
      </div>
      {/* <!-- gainners and loosers section --> */}
      <div className="row bottom-25">
        <PortfolioOverviewGainers />
        <PortfolioOverviewLooser />
      </div>
      <IncPortfolioNew />
    </>
  );
}

export default DetailsEquity;
